import { NgModule } from '@angular/core';
import { BaseSelectComponent } from './core/base-select.component';
import { BaseSingleSelectComponent } from './core/base-single-select.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseMultiSelectComponent } from './core/base-multi-select.component';
import { WchfsUiModule } from '@app/@wchfs-ui/lib/wchfs-ui.module';
import { BaseGroupedMultiSelectComponent } from '@pso-ui/select/core/base-grouped-multi-select.component';
import { TooltipOnOverflowDirective } from '@pso-ui/directives/wchfs-tooltip-on-overflow.directive';

@NgModule({
  declarations: [
    BaseSelectComponent,
    BaseSingleSelectComponent,
    BaseMultiSelectComponent,
    BaseGroupedMultiSelectComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, WchfsUiModule, TooltipOnOverflowDirective],
  exports: [BaseSelectComponent, BaseSingleSelectComponent, BaseMultiSelectComponent, BaseGroupedMultiSelectComponent],
})
export class SelectModule {}
